/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ArmModal",
  components: {
    customModal,
    VPagination
  },
  emits: ["closeModal", "saved", "refreshArmList"],
  props: {
    editingId: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      selectedArmId: null,
      newArm: {
        armName: '',
        armCode: '',
        active: true,
        description: '',
        SoAId: '',
      },
      statusError: '',
      isEditMode: false,
      studyId: "",
      loading: false,
      errors: {
        armName: false,
        armCode: false
      },
      studySoAList: [],
      errorMessages: {
        armName: '',
        armCode: ''
      }
    };
  },

  async mounted() {     
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;
    console.log("Modal mounted, editingId:", this.editingId);
    this.listStudySoAIds();
    
    // If editingId is provided, fetch the ARM data
    if (this.editingId) {
      this.isEditMode = true;
      this.listStudySoAIds();
      await this.fetchArmById();
    }
  },

  methods: {
    clearErrors() {
      this.errors.armName = false;
      this.errors.armCode = false;
      this.errorMessages.armName = '';
      this.errorMessages.armCode = '';
    },

    validate() {
      this.clearErrors();
      let isValid = true;

      if (!this.newArm.armName || !this.newArm.armName.trim()) {
        this.errors.armName = true;
        this.errorMessages.armName = this.$t("navigations.please enter a arm name");
        isValid = false;
      }

      if (!this.newArm.armCode || !this.newArm.armCode.trim()) {
        this.errors.armCode = true;
        this.errorMessages.armCode = this.$t("navigations.please enter a arm code");
        isValid = false;
      }
   

      return isValid;
    },

    async fetchArmById() {
      if (!this.editingId) {
        console.log("No editing ID provided");
        return;
      }
      
      try {
        this.loading = true;
        console.log("Fetching ARM with ID:", this.editingId);
        
        const response = await axios.get(
          `${this.baseurl}/fhir-service/arm/getarmbyid?arm_id=${this.editingId}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        const armData = response.data;
        
        if (armData) {
   
          this.newArm = {
            armName: armData.ArmName || '',
            armCode: armData.ArmCode || '',
            armType: armData.ArmType || '',
            SoAId: armData.SoAId || '',
            active: armData.IsActive !== undefined ? armData.IsActive : true,
            description: armData.Description || ''
          };
          
        } else {
          console.error("No data received from API");
        }
      } catch (err) {
        console.error("Error fetching ARM data:", err);
        console.error("Error details:", err.response?.data);
        alert("Failed to load ARM data for editing");
      } finally {
        this.loading = false;
      }
    },

    async submitNewArm() {
      const isValid = this.validate();
      if (!isValid) {
        return;
      }

      const idtoken = store.getters.getIdToken;

      const payload = {
        ...(this.isEditMode && this.editingId ? { Id: this.editingId } : {}),
        StudyId: this.studyId,
        ArmCode: this.newArm.armCode || "",
        ArmName: this.newArm.armName,
        ArmType: this.newArm.armType || "",
        SoAId: this.newArm.SoAId || "",
        Description: this.newArm.description || "",
        IsActive: this.newArm.active,
        CreatedUserId: store.getters.getUserId,
        CreatedUserEmail: store.getters.getUserEmail,
        CreatedAt: new Date().toISOString(),
        LastModifiedUserId: store.getters.getUserId,
        LastModifiedUserEmail: store.getters.getUserEmail,
        LastModifiedAt: new Date().toISOString(),
      };
      try {
        if (this.isEditMode && this.editingId) {
          await axios.put(
            `${this.baseurl}/fhir-service/arm/updatearm?arm_id=${this.editingId}&study_id=${this.studyId}`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.arm updated successfully"));
        } else {
          await axios.post(
            `${this.baseurl}/fhir-service/arm/add`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.arm created successfully"));
        }

        this.$emit("saved");
        this.closeModal();
      } catch (err) {
        console.error("Save operation failed:", err);
        const backendMessage = err.response?.data?.detail || "";

        if (backendMessage.includes("ArmCode") && backendMessage.includes("already exists")) {
          alert("ArmCode already exists for this Study");
        } else if (backendMessage.includes("ARM item not found")) {
          alert(this.$t("navigations.arm updated successfully"));
          this.$emit("saved");
          this.closeModal();
        } else {
          alert(backendMessage || "Save operation failed");
        }
      }

    },

    closeModal() {
      this.$emit("closeModal");
    },
    
    resetForm() {
      this.newArm = {
        armName: '',
        armCode: '',
        active: true,
        armType: '',
        description: '',
        SoAId: ''
      };
      this.isEditMode = false;
      this.clearErrors();
    },
    async listStudySoAIds() {
      try {
        const idtoken = store.getters.getIdToken;

        const res = await axios.get(
          `${this.baseurl}/management/cohort/getallsoaids?StudyId=${this.studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.studySoAList = (res.data.data || [])
          .filter(item => item.isActive && !item.isDeleted)
          .map(item => ({
            value: item.soaId,
            label: item.soaId
          }));

        console.log("SOA dropdown list:", this.studySoAList);

      } catch (err) {
        console.log("error in listing SoA", err);
        this.studySoAList = [];
      }
    }
  }
};